import { defineStore } from 'pinia'
import type { Router, RouteLocationNormalizedLoaded } from 'vue-router'

export type TableSortOption = 'asc' | 'desc' | 'none'

export const useTableStore = defineStore('table', {
  state: () => ({
    perPage: 10 as number,
    search: '' as string,
    column: '' as string,
    sort: 'asc' as TableSortOption,
    total: 0 as number,
    page: 1 as number,
    cat: null as number | null,
    branch: 'all' as string | null,
    loaded: false as boolean,
  }),
  actions: {
    async setPerPage(val: number, router: Router, route: RouteLocationNormalizedLoaded) {
      this.perPage = val

      const existingQuery = { ...route.query }
      existingQuery.perPage = String(val)

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    async setSearch(val: string, router: Router, route: RouteLocationNormalizedLoaded) {
      this.search = val

      const existingQuery = { ...route.query }
      existingQuery.search = String(val)

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    resetSearch() {
      this.search = '' as string
    },
    async sortColumn(
      column: string,
      sort: TableSortOption,
      router: Router,
      route: RouteLocationNormalizedLoaded,
    ) {
      this.column = column
      this.sort = sort

      const existingQuery = { ...route.query }
      existingQuery.column = String(column)
      existingQuery.sort = String(sort)

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    setTotal(total: number) {
      this.total = total
    },
    async setPage(val: number, router: Router, route: RouteLocationNormalizedLoaded) {
      this.page = val

      const existingQuery = { ...route.query }
      existingQuery.page = String(val)

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    async setCategory(
      val: number | null,
      router: Router,
      route: RouteLocationNormalizedLoaded,
      sortColumn: string = '',
    ) {
      this.cat = val
      if (sortColumn) {
        this.column = sortColumn
        this.sort = 'desc'
      }

      const existingQuery = { ...route.query }
      existingQuery.cat = val !== null ? String(val) : ''

      if (sortColumn) {
        existingQuery.column = String(sortColumn)
        existingQuery.sort = 'desc'
      }

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    async setBranch(val: string | null, router: Router, route: RouteLocationNormalizedLoaded) {
      this.branch = val

      const existingQuery = { ...route.query }
      existingQuery.branch = String(val)

      await router.replace({
        path: route.path,
        query: existingQuery,
      })
    },
    setLoaded(val: boolean) {
      this.loaded = val
    },
  },
})
